/**
 * 在运行阶段初始化layout-wiz使用的相关store
 * @param store
 * @param router
 * @see https://v3.vuex.vuejs.org/zh/guide/modules.html 模块动态注册
 */

import Auth from './modules/Auth.models'
import System from './modules/System.models'
import Sites from './modules/Sites.models'
import Abp from './modules/Abp.models'

const modules = {
  Auth,
  System,
  Sites,
  Abp,
}

export default (store, router) => {
  // 可以通过 store.hasModule(moduleName) 方法检查该模块是否已经被注册到 store
  // store.registerModule(['Auth'], Auth, { namespaced: true })
  const persistedState = JSON.parse(localStorage.getItem('vuex'))
  Object.keys(modules).forEach((key) => {
    if (store.hasModule(key)) {
      store.unregisterModule(key)
    }
    store.registerModule(key, modules[key])
    if (persistedState && Object.prototype.hasOwnProperty.call(persistedState, key)) {
      store.commit(`${key}/updateState`, { payload: persistedState[key] })
    }
  })
}
